import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { cacTram, SO_TRAM, layTram, linkViec, taiLieuHoTro } from "../data/lo-trinh.js";
import { TOOLS } from "../data/tools.js";
import { PLAYBOOK_POSTS } from "../data/playbook.js";
import { TEMPLATES } from "../data/templates.js";
import { mauCuaTram } from "../data/mauTram.js";
import { readWorkspace } from "../lib/workspace.js";
import { track } from "../lib/track.js";
import { docGoiY, KHOA_NGANH } from "../lib/goiYTram.js";
import { trangThaiViec } from "../components/TienDoLoTrinh.jsx";
import LoTrinhKhung from "../components/LoTrinhKhung.jsx";
import { KhungHaiCot, NhomLoc } from "../components/LocHaiCot.jsx";

/**
 * /lo-trinh: hành trình gọi vốn 5 trạm, gọn trong một màn hình.
 *
 * Cùng ngôn ngữ thiết kế với /cong-cu: đầu trang chữ bên trái, khung xanh bên
 * phải (mỗi cột một trạm, mỗi ô một việc), chip chọn trạm, lưới thẻ việc.
 * Chỉ hiện việc của một trạm mỗi lúc; các trạm khác vẫn nằm trong HTML (thuộc
 * tính hidden) nên vẫn được lập chỉ mục và #neo trên URL vẫn dùng được.
 *
 * Trạm chọn sẵn: trạm trùng #neo; không có thì trạm được gợi ý từ lần chấm
 * Điểm sẵn sàng (localStorage); không có thì trạm đầu tiên chưa xong theo tiến
 * độ; còn lại là Trạm 1.
 */

const URL_CHAM_DIEM = "/cong-cu/diem-san-sang-goi-von";

const congCu = (s) => TOOLS.find((x) => x.slug === s);
const tenBai = (s) => PLAYBOOK_POSTS.find((x) => x.slug === s)?.title;
const tenMau = (s) => TEMPLATES.find((x) => x.slug === s)?.title;

const NHAN_TT = { xong: "Đã xong", "co-ket-qua": "Có kết quả" };

function docNganh() {
  try { return window.localStorage.getItem(KHOA_NGANH) || ""; } catch { return ""; }
}
function ghiNganh(v) {
  try { window.localStorage.setItem(KHOA_NGANH, v); } catch { /* chế độ riêng tư */ }
}

function TheViec({ tram, viec, stt, nganh, tt }) {
  const to = linkViec(tram, viec, nganh);
  const phut = viec.dich?.loai === "congCu" ? congCu(viec.dich.slug)?.minutes : null;
  const phu = (viec.phu || []).filter((p) => congCu(p.slug));
  return (
    <li className={"ltv" + (tt !== "chua" ? " co" : "")}>
      <span className="ltv-dau">
        <span className="ltv-so" aria-hidden="true">{tt !== "chua" ? "✓" : stt}</span>
        {NHAN_TT[tt] && <span className="ltv-tt">{NHAN_TT[tt]}</span>}
      </span>
      <h3 className="ltv-ten">{viec.ten}</h3>
      <p className="ltv-chuan-bi"><b>Chuẩn bị:</b> {viec.chuanBi}</p>
      {viec.khi && <p className="ltv-khi">{viec.khi}</p>}
      {phu.length > 0 && (
        <p className="ltv-phu">
          Hoặc:{" "}
          {phu.map((p, i) => (
            <span key={p.slug}>
              {i > 0 && ", "}
              <Link to={`/cong-cu/${p.slug}`} title={p.ghiChu}>{congCu(p.slug).title}</Link>
            </span>
          ))}
        </p>
      )}
      <span className="cct-chan ltv-chan">
        {phut ? <span>{phut} phút</span> : null}
        <Link
          className="cct-dung"
          to={to}
          onClick={() => track("bam_viec", { tram: tram.id, viec: stt, dich: to })}
        >
          {viec.nhan} →
        </Link>
      </span>
    </li>
  );
}

function HoTro({ tram, nganh }) {
  const { playbook, mau } = taiLieuHoTro(tram, nganh);
  const bai = playbook.map((s) => ({ to: `/playbook/${s}`, label: tenBai(s) })).filter((x) => x.label);
  const mauEx = mau.map((s) => ({ to: `/mau/${s}`, label: tenMau(s) })).filter((x) => x.label);
  const tong = bai.length + mauEx.length;
  if (!tong) return null;
  return (
    <details className="tram-ho-tro ltp-ho-tro">
      <summary>Hướng dẫn và ví dụ cho trạm này ({tong})</summary>
      <ul>
        {bai.map((x) => (
          <li key={x.to}><span className="loai">Bài</span><Link to={x.to}>{x.label}</Link></li>
        ))}
        {mauEx.map((x) => (
          <li key={x.to}><span className="loai">Mẫu Excel</span><Link to={x.to}>{x.label}</Link></li>
        ))}
      </ul>
    </details>
  );
}

export default function LoTrinh() {
  const { hash } = useLocation();
  const ds = cacTram();
  const [goiY, setGoiY] = useState(null);
  const [chon, setChon] = useState(ds[0].id);
  const [nganh, setNganh] = useState("");
  const [tienDo, setTienDo] = useState(null); // { [tram.id]: ["xong" | "co-ket-qua" | "chua"] }

  // Chỉ đọc localStorage sau khi mount: trang được prerender, HTML ban đầu
  // phải giống nhau cho mọi người.
  useEffect(() => {
    const g = docGoiY();
    setGoiY(g);
    setNganh(docNganh());
    let td = null;
    try {
      const d = readWorkspace();
      td = Object.fromEntries(ds.map((t) => [t.id, t.viec.map((v, i) => trangThaiViec(d, t, v, i))]));
      if (!Object.values(td).flat().some((x) => x !== "chua")) td = null;
    } catch { /* bộ nhớ trình duyệt bị chặn */ }
    setTienDo(td);

    const idHash = (hash || "").replace("#", "");
    const tramHash = ds.find((t) => t.id === idHash);
    if (tramHash) {
      setChon(tramHash.id);
      track("mo_tram", { tram: tramHash.id, method: "hash" });
      requestAnimationFrame(() => document.getElementById("lt-bang")?.scrollIntoView({ block: "start" }));
    } else if (g?.tram && layTram(g.tram)) {
      setChon(layTram(g.tram).id);
    } else if (td) {
      const dau = ds.find((t) => td[t.id].some((x) => x === "chua"));
      if (dau) setChon(dau.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hash]);

  // id rỗng = xem tất cả các trạm.
  const chonTram = (id, cach, cuon) => {
    setChon(id);
    if (id) track("mo_tram", { tram: id, method: cach });
    try { window.history.replaceState(window.history.state, "", id ? `#${id}` : window.location.pathname); } catch { /* bỏ qua */ }
    if (cuon) requestAnimationFrame(() => document.getElementById("lt-bang")?.scrollIntoView({ behavior: "smooth", block: "nearest" }));
  };

  const tramGoiY = goiY?.tram ? layTram(goiY.tram) : null;
  const tramNganh = ds.find((t) => t.theoNganh);
  const ttCua = (t) => tienDo?.[t.id] || t.viec.map(() => "chua");
  const cacCot = ds.map((t) => ({ tram: t, mau: mauCuaTram(t), tt: ttCua(t) }));
  const tongViec = ds.reduce((a, t) => a + t.viec.length, 0);
  const soCoKq = tienDo ? Object.values(tienDo).flat().filter((x) => x !== "chua").length : 0;
  const tongPhut = ds.reduce(
    (a, t) => a + t.viec.reduce((b, v) => b + ((v.dich?.loai === "congCu" && congCu(v.dich.slug)?.minutes) || 0), 0),
    0,
  );
  const moc = tramGoiY?.id || (tienDo ? ds.find((t) => tienDo[t.id].some((x) => x === "chua"))?.id : null) || null;

  return (
    <div className="lo-trinh lt2">
      <div className="cc-dau lt-dau">
        <header>
          <p className="eyebrow">LỘ TRÌNH GỌI VỐN</p>
          <h1>Gọi vốn lần đầu:<br /> bắt đầu từ đâu?</h1>
          <p className="lead">
            {SO_TRAM} trạm, mỗi trạm là vài việc cụ thể. Không cần đi theo thứ tự:
            bắt đầu ở trạm bạn đang cần.
          </p>
          {tramGoiY ? (
            <>
              <p className="lt-goi-y">
                {goiY.ngay ? `Theo lần chấm ngày ${goiY.ngay}, nên` : "Nên"} bắt đầu ở <b>Trạm {tramGoiY.so}: {tramGoiY.ten}</b>
              </p>
              <div className="cc-dau-nut">
                <button type="button" className="nut" onClick={() => chonTram(tramGoiY.id, "goi_y", true)}>
                  Xem việc Trạm {tramGoiY.so} →
                </button>
                <Link className="cc-dau-link" to={URL_CHAM_DIEM}>Chấm lại →</Link>
              </div>
            </>
          ) : (
            <div className="cc-dau-nut">
              <Link className="nut" to={URL_CHAM_DIEM}>Tìm trạm bắt đầu →</Link>
              <span className="lt-ghi-chu">Vài câu hỏi, không cần tài khoản</span>
            </div>
          )}
        </header>
        <LoTrinhKhung
          cacCot={cacCot}
          dangChon={chon}
          moc={moc}
          onChon={(id) => chonTram(id, "ban_do", true)}
          chan={
            tienDo
              ? <>Đã có kết quả <b>{soCoKq}/{tongViec}</b> việc, lưu trong <Link to="/ban-chuan-bi">Bản chuẩn bị của tôi</Link></>
              : <><b>{tongViec}</b> việc, khoảng <b>{tongPhut}</b> phút với các công cụ, không cần tài khoản</>
          }
        />
      </div>

      <div id="lt-bang">
        <KhungHaiCot
          soDangChon={(chon ? 1 : 0) + (nganh ? 1 : 0)}
          boLoc={<>
            <NhomLoc
              tieuDe="Trạm"
              mot
              tatCa="Tất cả các trạm"
              tatCaDem={tongViec}
              chon={chon ? [chon] : []}
              onDoi={(v) => chonTram(v[0] || "", "loc")}
              gioiHan={10}
              ds={cacCot.map(({ tram: t, mau, tt }) => ({
                v: t.id,
                nhan: `Trạm ${t.so}: ${t.ten}`,
                title: t.cauHoi,
                dem: tienDo ? `${tt.filter((x) => x !== "chua").length}/${t.viec.length}` : t.viec.length,
                mau,
              }))}
            />
            {tramNganh && (
              <NhomLoc
                tieuDe="Ngành của bạn"
                mot
                tatCa="Chưa chọn"
                chon={nganh ? [nganh] : []}
                onDoi={(v) => {
                  const moi = v[0] || "";
                  setNganh(moi);
                  ghiNganh(moi);
                  if (moi) track("chon_nganh", { value: moi });
                }}
                ds={Object.entries(tramNganh.theoNganh).map(([id, n]) => ({ v: id, nhan: n.ten }))}
              />
            )}
            {tramNganh && <p className="lt-loc-ghi">Chọn ngành để Trạm {tramNganh.so} dẫn thẳng tới mẫu mô hình tài chính của ngành bạn.</p>}
          </>}
        >
          {ds.map((t) => {
            const tt = ttCua(t);
            return (
              <section
                key={t.id}
                id={t.id}
                className="ltp"
                hidden={Boolean(chon) && chon !== t.id}
                aria-labelledby={`${t.id}-tieu-de`}
                style={{ "--mau": mauCuaTram(t) }}
              >
                <div className="ltp-dau">
                  <h2 id={`${t.id}-tieu-de`}>
                    <span className="ltp-so">Trạm {t.so}</span>
                    {t.cauHoi}
                    {tramGoiY?.id === t.id && <span className="cct-nen">Nên bắt đầu ở đây</span>}
                  </h2>
                  <p className="ltp-kq"><b>Kết quả cần có:</b> {t.mangVe}</p>
                </div>
                <ol className="ltp-luoi">
                  {t.viec.map((v, i) => (
                    <TheViec key={v.ten} tram={t} viec={v} stt={i + 1} nganh={nganh} tt={tt[i]} />
                  ))}
                </ol>
                <HoTro tram={t} nganh={nganh} />
              </section>
            );
          })}
        </KhungHaiCot>
      </div>
    </div>
  );
}
